import(/* webpackMode: "eager" */ "/app/src/app/about/team/page.tsx");
